export const EVENT_LIST_BY_ESTABLISHMENT = 'event-list-by-establishment';
export const EVENT_PAGE = 'event-page';
export const EVENT_PAGE_INVITATION = 'event-page-invitation';
export const ERROR_404 = '404';
export const AUTH_FORGOT_PASSWORD = 'auth-forgot-password';
export const AUTH_REGISTER = 'auth-register';
export const AUTH_LOGIN = 'auth-login';
